import { render, staticRenderFns } from "./MainExpert.vue?vue&type=template&id=c90360b6&scoped=true"
import script from "./MainExpert.vue?vue&type=script&lang=js"
export * from "./MainExpert.vue?vue&type=script&lang=js"
import style0 from "./MainExpert.vue?vue&type=style&index=0&id=c90360b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90360b6",
  null
  
)

export default component.exports